"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _operators = require("rxjs/operators");

var _sequence = _interopRequireDefault(require("./sequence"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var sequenceBy = function sequenceBy(selector) {
  return function () {
    return (0, _operators.pipe)((0, _operators.groupBy)(selector), (0, _operators.mergeMap)(_sequence["default"].apply(void 0, arguments)));
  };
};

var _default = sequenceBy;
exports["default"] = _default;